import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";

import {
  makeStyles,
  createTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import { IconButton } from "@material-ui/core";
import { MoreVert, Replay, Sync } from "@material-ui/icons";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import TicketOptionsMenu from "../TicketOptionsMenu";
import ButtonWithSpinner from "../ButtonWithSpinner";
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";
import { AuthContext } from "../../context/Auth/AuthContext";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import UndoRoundedIcon from "@material-ui/icons/UndoRounded";
import Tooltip from "@material-ui/core/Tooltip";
import { green, red } from "@material-ui/core/colors";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import updateTicketStatus from "../../utils/updateTicketStatus";

const useStyles = makeStyles((theme) => ({
  actionButtons: {
    marginRight: 6,
    flex: "none",
    alignSelf: "center",
    marginLeft: "auto",
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
}));

const TicketActionButtonsCustom = ({ ticket, onSync }) => {
  const classes = useStyles();
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const ticketOptionsMenuOpen = Boolean(anchorEl);
  const { user } = useContext(AuthContext);
  const { setCurrentTicket } = useContext(TicketsContext);

  const isGroupMember = ticket?.contact?.groupUsers?.some(
    (ug) => Number(ug.userId) === Number(user?.id),
  );

  const customTheme = createTheme({
    palette: {
      primary: green,
      secondary: red,
    },
  });

  const handleOpenTicketOptionsMenu = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleCloseTicketOptionsMenu = (e) => {
    setAnchorEl(null);
  };

  const handleUpdateTicketStatus = async (
    e,
    status,
    userId,
    skipFarewell = false,
  ) => {
    await updateTicketStatus({
      ticket,
      status,
      userId,
      skipFarewell,
      history,
      setCurrentTicket,
      setLoading,
      onError: toastError,
    });
  };

  const handleSyncMessages = async () => {
    setSyncing(true);
    try {
      await api.post(`/messages/${ticket.id}/sync`);
      toast.success(i18n.t("messagesList.toasts.sync"));
      onSync && onSync();
    } catch (err) {
      toastError(err);
    }
    setSyncing(false);
  };

  return (
    <div className={classes.actionButtons}>
      {/*<Tooltip title={i18n.t("messagesList.header.buttons.sync")}>
        <span>
          <IconButton onClick={handleSyncMessages} disabled={syncing}>
            <Sync />
          </IconButton>
        </span>
      </Tooltip>*/}
      {ticket.status === "closed" && (
        <ButtonWithSpinner
          loading={loading}
          startIcon={<Replay />}
          size="small"
          onClick={(e) => handleUpdateTicketStatus(e, "open", user?.id)}
        >
          {i18n.t("messagesList.header.buttons.reopen")}
        </ButtonWithSpinner>
      )}
      {ticket.status === "open" && (
        <>
          <Tooltip title={i18n.t("messagesList.header.buttons.return")}>
            <IconButton
              onClick={(e) => handleUpdateTicketStatus(e, "pending", null)}
            >
              <UndoRoundedIcon />
            </IconButton>
          </Tooltip>
          <ThemeProvider theme={customTheme}>
            <Tooltip title={i18n.t("messagesList.header.buttons.resolve")}>
              <IconButton
                onClick={(e) => handleUpdateTicketStatus(e, "closed", user?.id)}
                color="primary"
              >
                <CheckCircleIcon />
              </IconButton>
            </Tooltip>
            <Tooltip
              title={i18n.t(
                "messagesList.header.buttons.resolveWithoutMessage",
              )}
            >
              <IconButton
                onClick={(e) =>
                  handleUpdateTicketStatus(e, "closed", user?.id, true)
                }
                color="secondary"
              >
                <CheckCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          </ThemeProvider>

          {/* <ButtonWithSpinner
						loading={loading}
						startIcon={<Replay />}
						size="small"
						onClick={e => handleUpdateTicketStatus(e, "pending", null)}
					>
						{i18n.t("messagesList.header.buttons.return")}
					</ButtonWithSpinner>
					<ButtonWithSpinner
						loading={loading}
						size="small"
						variant="contained"
						color="primary"
						onClick={e => handleUpdateTicketStatus(e, "closed", user?.id)}
					>
						{i18n.t("messagesList.header.buttons.resolve")}
					</ButtonWithSpinner> */}
          <IconButton onClick={handleOpenTicketOptionsMenu}>
            <MoreVert />
          </IconButton>
          <TicketOptionsMenu
            ticket={ticket}
            anchorEl={anchorEl}
            menuOpen={ticketOptionsMenuOpen}
            handleClose={handleCloseTicketOptionsMenu}
          />
        </>
      )}
      {ticket.status === "pending" && (!ticket.isGroup || isGroupMember) && (
        <ButtonWithSpinner
          loading={loading}
          size="small"
          variant="contained"
          color="primary"
          onClick={(e) => handleUpdateTicketStatus(e, "open", user?.id)}
        >
          {i18n.t("messagesList.header.buttons.accept")}
        </ButtonWithSpinner>
      )}
    </div>
  );
};

export default TicketActionButtonsCustom;
